export default "<p>\r\n  score-updater works!\r\n  <label>JSON: {{_json }}</label>\r\n</p>\r\n";